import { ControlProps, isControl, rankWith } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";

const ValueBadgeRenderer = (props: ControlProps) => {
  const styles: Record<string, React.CSSProperties> =
    (props.uischema as any)?.options?.styles ?? {};
  const baseStyle: React.CSSProperties = styles["."] ?? {};
  const valueStyle: React.CSSProperties = styles[String(props.data)] ?? {};
  const merged = { ...baseStyle, ...valueStyle };

  return (
    <div className="control">
      <label>{props.label}</label>
      <div>
        <span style={merged}>{props.data ?? ""}</span>
      </div>
    </div>
  );
};

export const valueBadgeRendererTester = rankWith(100, (uischema) => {
  if (!isControl(uischema)) return false;
  return (uischema as any).options?.variant === "valueBadge";
});

export default withJsonFormsControlProps(ValueBadgeRenderer);
